<template>
  <v-container fluid tag="section">
    <v-timeline align-top dense>
      <v-timeline-item v-for="(step, ind) in item" :key="ind" small>
        <template v-slot:icon>
          <v-avatar size="30">
            <img :src="step.createUser.avatar">
          </v-avatar>
        </template>
        <v-row class="pt-1">
          <v-col>
            <div class="text-caption mb-2">
              {{step.createTime | formatRelativeTime}}
            </div>
            <div class="text-caption">
              {{step.createUser.name}}---{{step.content}}
            </div>
          </v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>
    <!-- <v-list three-line>
      <template v-for="(i, idx) in item">
        <v-list-item :key="idx">
          <v-list-item-avatar>
            <v-img :src="i.createUser.avatar"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{i.createTime | formatDate}}</v-list-item-title>
            <v-list-item-subtitle>{{i.createUser.name}}---{{i.content}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-1" v-if="idx + 1 < item.length"></v-divider>
      </template>
    </v-list> -->
  </v-container>
</template>

<script>
  export default {
    name: 'OrderRecord',
    components: {
    },
    props: {
      item: {
        type: Array,
        default: () => ([])
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>

<style>
</style>
